import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, DetailedUser } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

type SimpleUserInfo = Pick<DetailedUser, 'email' | 'fullName' | 'id' | 'phone' | 'role' | 'groups' | 'enabled'>;

export default function useBulkUserInfo(
    userIdQueryParams: string,
    config: customSWRConfig = {}
): customSWRResponse<SimpleUserInfo[]> {
    const keys = useSWRCacheKeys(userIdQueryParams ? `/users/ids?ids=${userIdQueryParams}` : null);

    return useSWR<SimpleUserInfo[]>(keys, { ...config });
}

export { type SimpleUserInfo };
